import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo-fio.svg';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const [mostrarSenha, setMostrarSenha] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);

    try {
      await login(username, senha);
      navigate('/ti/atendimentos');
    } catch (err) {
      setErro(err.response?.data?.message || err.response?.data?.error || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'radial-gradient(circle at 30% 20%, #17402E 0%, #0A130D 45%, #04080A 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{ width: '100%', maxWidth: 420, padding: '0 16px' }}>
        <div
          className="card p-4 p-md-5"
          style={{
            background: '#16241B',
            color: '#E4ECEF',
            border: '1px solid #294034',
            borderRadius: 20,
            boxShadow: '0 24px 60px rgba(0,0,0,0.55), 0 0 0 1px rgba(61, 139, 55,0.08)',
          }}
        >
          <div className="text-center mb-4">
            <img
              src={logo}
              alt="Fio"
              style={{ width: 180, height: 'auto', marginBottom: 16 }}
            />
            <h4 style={{ color: '#57A94F', fontWeight: 700, marginBottom: 2 }}>
              Fio
            </h4>
            <p style={{ color: '#93A99C', fontSize: '0.82rem', margin: 0 }}>
              Plataforma de Atendimento
            </p>
          </div>

          {erro && (
            <div className="alert alert-danger py-2 px-3" style={{ fontSize: '0.85rem' }}>
              {erro}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-semibold" style={{ fontSize: '0.85rem' }}>
                Usuário
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="seu.usuario"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold" style={{ fontSize: '0.85rem' }}>
                Senha
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type={mostrarSenha ? 'text' : 'password'}
                  className="form-control"
                  placeholder="••••••••"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  required
                  style={{ paddingRight: 42 }}
                />
                <button
                  type="button"
                  onClick={() => setMostrarSenha((v) => !v)}
                  aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                  title={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                  style={{
                    position: 'absolute', top: '50%', right: 8, transform: 'translateY(-50%)',
                    background: 'transparent', border: 'none', cursor: 'pointer',
                    color: '#93A99C', fontSize: '1.05rem', lineHeight: 1, padding: 4,
                  }}
                >
                  <i className={`bi ${mostrarSenha ? 'bi-eye-slash' : 'bi-eye'}`} />
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="btn w-100 fw-semibold"
              style={{
                background: 'linear-gradient(135deg, #3D8B37 0%, #2E6A29 100%)',
                color: '#fff',
                border: 'none',
                padding: '10px',
                boxShadow: '0 8px 20px rgba(61, 139, 55,0.35)',
              }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Entrando...
                </>
              ) : (
                'Entrar'
              )}
            </button>
          </form>

          <div className="text-center mt-3" style={{ color: '#5E7A82', fontSize: '0.72rem' }}>
            Centrão Materiais de Construção
          </div>
        </div>
      </div>
    </div>
  );
}
